export const config = {
  vastApiBaseUrl: import.meta.env.VITE_VAST_API_BASE_URL,
  clientId: import.meta.env.VITE_CLIENT_ID,
  referralsFrontendUrl: import.meta.env.VITE_REFERRALS_FRONTEND_URL,
  currencyApiBaseUrl: import.meta.env.VITE_CURRENCY_API_BASE_URL,
  marketplaceApiBaseUrl: import.meta.env.VITE_MARKETPLACE_API_BASE_URL,
  countryApiBaseUrl: import.meta.env.VITE_COUNTRY_API_BASE_URL,
  globalGivingBaseUrl: import.meta.env.VITE_GLOBALGIVING_BASE_URL,
  singleSignOnUrl: import.meta.env.VITE_SINGLE_SIGN_ON_URL,
  authBackendForFrontend: import.meta.env.VITE_AUTH_BACKEND_FOR_FRONTEND,
  documentTitleEnding: import.meta.env.VITE_DOCUMENT_TITLE_ENDING ?? "",
} as const
